module.exports = __webpack_public_path__ + "static/img/jm-m-logo1.b52b00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jm/jm-m-logo1.png
// module id = 4AT4
// module chunks = 13